import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';

export const CstmTextField = styled(TextField)({
    "& .MuiFormLabel-root.Mui-error": {
        color: "#F3284B !important"
    },
    "& .MuiFormHelperText-root.Mui-error": {
        color: "#F3284B !important"
    },
    '& input:valid + fieldset': {
        borderRadius: '12px !important',
        borderColor: '#E2EFFC',
    },
    '& .Mui-disabled': {
        borderRadius: '12px !important',
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderRadius: '12px !important',
        borderColor: '#E2EFFC',
    }, 
    '& .MuiOutlinedInput-root': {
        backgroundColor: '#E2EFFC !important',
        borderRadius: '12px !important',
        '&:hover fieldset': {
            borderColor: '#E2EFFC',
        },
        '&:hover': {
            backgroundColor: '#fff !important',
        }
    },
    '& .css-hgn91k-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled.MuiOutlinedInput-notchedOutline': {
        borderColor: '#E2EFFC',
    },
    '& .css-wiub46-MuiInputBase-root-MuiOutlinedInput-root.Mui-disabled': {
        borderColor: '#E2EFFC',
    },
    '.css-1ewifw0-MuiButtonBase-root-MuiChip-root':{
        backgroundColor:'#fff',
        borderRadius:'10px'
    },
    "& .MuiInputBase-input.Mui-disabled": {
        "WebkitTextFillColor": "grey !important",
        '&:hover fieldset': {
            borderColor: '#E2EFFC',
            backgroundColor: '#E2EFFC !important',
        },
      },
      "& .Mui-disabled .MuiOutlinedInput-notchedOutline": {
        borderColor: '#E2EFFC',
        '& .css-1aqewle-MuiFormControl-root-MuiTextField-root .MuiOutlinedInput-root:hover': {
            backgroundColor: '#E2EFFC !important',
            borderColor: '#E2EFFC',
        }
      }
}); 